import { Axios } from '../axiosInstance';

const axiosInstance = Axios();

const uploadProgressManager = {
  getUploadProgress(url: any) {
    return axiosInstance.v2({
      url: url,
      method: 'GET'
    });
  }
};

export default uploadProgressManager;
